<template>
  <a
    v-if="url && label"
    class="salary-explanation-link"
    :class="{'salary-explanation-link--large': large}"
    :href="url"
    target="_blank"
    rel="noopener noreferrer">
    <span class="icon icon--info" aria-hidden="true"></span>
    <span>{{ label }}</span>
  </a>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
      label: string | null;
      url: string | null;
      large?: boolean;
    }>(),
    {
      large: false
    });
</script>
